import { BooleanInput } from '@angular/cdk/coercion';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	Input,
	OnDestroy,
	OnInit,
	ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'app/app.service';
import { SecurityContextSupplier } from 'app/core/authorization';
import { ProfileService } from 'app/core/user/profile.service';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { Subject, takeUntil } from 'rxjs';
import packageInfo from '../../../../../package.json';

@Component({
	selector: 'user',
	templateUrl: './user.component.html',
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
	exportAs: 'user',
})
export class UserComponent implements OnInit, OnDestroy {
	/* eslint-disable @typescript-eslint/naming-convention */
	static ngAcceptInputType_showAvatar: BooleanInput;
	/* eslint-enable @typescript-eslint/naming-convention */

	@Input() showAvatar: boolean = true;
	user: User;
	version = packageInfo.version;
	backendVersion = '';
	avatarUrl: string;

	private _unsubscribeAll: Subject<any> = new Subject<any>();

	/**
	 * Constructor
	 */
	constructor(
		private _changeDetectorRef: ChangeDetectorRef,
		private _router: Router,
		private _userService: UserService,
		private _profileService: ProfileService,
		// private _keycloakService: KeycloakService
		private _securityContextSupplier: SecurityContextSupplier,
		public readonly appService: AppService,
		private _httpClient: HttpClient
	) { }

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		// Subscribe to user changes
		this._userService.user$
			.pipe(takeUntil(this._unsubscribeAll))
			.subscribe((user: User) => {
				this.user = user;
				this.avatarUrl = this._profileService.getAvatarUrl();

				// Mark for check
				this._changeDetectorRef.markForCheck();
			});

		// Busca a versão do backend (não bloqueia; falha em silêncio)
		this._httpClient.get<{ version: string }>(`${environment.url}health/version`)
			.pipe(takeUntil(this._unsubscribeAll))
			.subscribe({
				next: (res) => { this.backendVersion = res?.version || ''; this._changeDetectorRef.markForCheck(); },
				error: () => { /* silencioso */ },
			});
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next(null);
		this._unsubscribeAll.complete();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Update the user status
	 *
	 * @param status
	 */
	updateUserStatus(status: string): void {
		// Return if user is not available
		if (!this.user) {
			return;
		}

		// Update the user
		this._userService
			.update({
				...this.user,
				status,
			})
			.subscribe();
	}

	/**
	 * Sign out
	 */
	async signOut(): Promise<void> {
		// this._router.navigate(['/sign-out']);
		// this._keycloakService.logout(environment.auth.logoutUri);
		this._securityContextSupplier.logout();
	}

	/**
	 * Sign out
	 */
	changelog(): void {
		// Tela de atualizações do sistema (lida de assets/atualizacoes/CHANGELOG.md).
		this._router.navigate(['/apps/atualizacoes']);
	}

	/**
	 * Navigate to profile page
	 */
	goToProfile(): void {
		this._router.navigate(['/profile']);
	}
}
